import {
  ADD_CAR_ELIGIBILITY_REQUEST,
  ADD_CAR_ELIGIBILITY_SUCCESS,
  ADD_CAR_ELIGIBILITY_FAILURE,
  ADD_CAR_UPLOAD_DOCUMENTS_REQUEST,
  ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS,
  ADD_CAR_UPLOAD_DOCUMENTS_FAILURE,
  ADD_CAR_PROCESS_REQUEST,
  ADD_CAR_PROCESS_SUCCESS,
  ADD_CAR_PROCESS_FAILURE,
  GET_SIGNED_TOKEN_REQUEST,
  GET_SIGNED_TOKEN_FAILURE,
  GET_USER_SIGNED_TOKEN_REQUEST,
  GET_USER_SIGNED_TOKEN_SUCCESS,
  GET_USER_SIGNED_TOKEN_FAILURE,
  REMOVE_CAR_REQUEST,
  REMOVE_CAR_SUCCESS,
  REMOVE_CAR_FAILURE,
  CONFIRM_TRANSFER_REQUEST,
  CONFIRM_TRANSFER_SUCCESS,
  CONFIRM_TRANSFER_FAILURE,
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
} from '../types';

const initialState = {
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
    case ADD_CAR_ELIGIBILITY_REQUEST:
    case ADD_CAR_UPLOAD_DOCUMENTS_REQUEST:
    case ADD_CAR_PROCESS_REQUEST:
    case GET_SIGNED_TOKEN_REQUEST:
    case GET_USER_SIGNED_TOKEN_REQUEST:
    case REMOVE_CAR_REQUEST:
    case CONFIRM_TRANSFER_REQUEST:
      return {
        show: true,
      };
    case HIDE_GLOBAL_LOADER:
    case ADD_CAR_ELIGIBILITY_SUCCESS:
    case ADD_CAR_ELIGIBILITY_FAILURE:
    case ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS:
    case ADD_CAR_UPLOAD_DOCUMENTS_FAILURE:
    case ADD_CAR_PROCESS_SUCCESS:
    case ADD_CAR_PROCESS_FAILURE:
    case GET_SIGNED_TOKEN_FAILURE:
    case GET_USER_SIGNED_TOKEN_SUCCESS:
    case GET_USER_SIGNED_TOKEN_FAILURE:
    case REMOVE_CAR_SUCCESS:
    case REMOVE_CAR_FAILURE:
    case CONFIRM_TRANSFER_SUCCESS:
    case CONFIRM_TRANSFER_FAILURE:
      return {
        show: false,
      };

    default:
      return state;
  }
};
